import CreateNoteForm from 'domain/people/employee/Timeline/note/form/CreateNoteForm';
import React from 'react';
import { FormFieldsData, FormTemplateProps } from 'framework/form';

interface LightTimelineNoteFormProps {
  onCancel: () => void;
  submitFormFunc: (values: FormFieldsData) => Promise<object | void>;
  afterSubmit?: FormTemplateProps['afterSubmit'];
}

const LightTimelineNoteForm: React.FC<LightTimelineNoteFormProps> = ({ onCancel, submitFormFunc, afterSubmit }) => {
  return <CreateNoteForm onCancel={onCancel} submitFormFunc={submitFormFunc} afterSubmit={afterSubmit} />;
};

export default LightTimelineNoteForm;
